export default __webpack_public_path__ + "static/media/SEC1350.34I-30006_-17401_0.1361b55e.jpg";